import Animation from './animation'
import * as d3 from 'd3-selection'

/*
 * This animation is used when a new slice (i.e. serie) is added to a pie/donut
 * chart
 */
class Entering extends Animation {

  match (serie) {
    // See if this serie exists as a pie, if we're now a donut; or as a donut if
    // we're now a pie.
    let serieExists = this.chart.selectAll('g.serie')
                                .filter(function () {
                                  if (serie.type === 'pie') {
                                    // See if this is a donut
                                    return this.dataset.serieType === 'donut'
                                  }
                                  if (serie.type === 'donut') {
                                    return this.dataset.serieType === 'pie'
                                  }
                                })

    return this.seriesChanged &&
           this.previous.series.data().indexOf(serie) === -1 && // We didn't have this serie previously
           !serieExists.size() // If it exists as the opposite type (pie/dontu)
                               // we don't enter.
  }

  animate (serie, entering, selection, merged, exiting) {
    let prev = this.previousPies
      , series = this.series.selection().data()
      , self = this

    entering.select(d => {
      let path = d3.select(`#${d.pathUid.id}`)

      // Adjust the starting point `this._current` on the new path
      path.each(function () {
        this._current = Object.assign({}, d.slice)

        // Set the current angle
        if (prev) {
          let prevPie = self.getPie(d.rangeId, prev)

          // This is an update
          if (d.slice.index === 0 && prevPie) {
            // First slice is easy, will start at 0
            this._current.endAngle = this._current.startAngle
          } else if (prevPie) {
            // Look up the previous serie in the pie's angles
            // What serie is before this serie
            let prevSerie = series[d.slice.index - 1]
              , endAngle = prevPie.slices.find(slice => {
                                    return slice.data.serieId === prevSerie.id
                                  }).endAngle

            this._current.startAngle = endAngle
            this._current.endAngle = endAngle
          }
        }
      })
    })

    merged.call(this.fadeIn, this.styles)
          .call(this.tweenPath, this.arcTweener)
  }

}

export default Entering
